import { PropsWithChildren } from 'react';
import { VStack, styled, Text } from '@cad-arc';
import { FrCreateOrEditEventFormSectionTitle } from './fr-create-or-edit-event-form-section-title';
import { EntitiesType } from './types';

const StyledVStack = styled(VStack)`
    align-items: flex-start;
    gap: 10px;
    height: 100%;
    width: 33%;
    padding-top: var(--arc-space-6);

    @media (max-width: 1200px) {
        width: 100%;
        padding: 0 var(--arc-space-6) var(--arc-space-6) var(--arc-space-6);
    }
`;

export function FrCreateOrEditEventFormPersonsAndVehiclesWrapper({
    children,
    entitiesType,
    noEntities,
}: PropsWithChildren<{
    entitiesType: EntitiesType;
    noEntities: boolean;
}>) {
    return (
        <StyledVStack>
            <FrCreateOrEditEventFormSectionTitle title={entitiesType} />
            <VStack w="100%" alignItems="flex-start" overflowY="auto" padding={0} margin={0}>
                {noEntities ? (
                    <Text color="tertiary" style={{ width: '100%' }}>
                        No {entitiesType}
                    </Text>
                ) : (
                    children
                )}
            </VStack>
        </StyledVStack>
    );
}
